import { Button, Checkbox, Input, List, Message, Space, Spin } from '@arco-design/web-react'
import { IconMessage, IconSearch } from '@arco-design/web-react/icon'
import React, { useEffect, useRef, useState } from 'react'
import './WorkList.less'
import collectImg from "@/assets/comment/collect.png"
import loveImg from "@/assets/comment/love.png"
import playerImg from "@/assets/comment/player.png"
import playImg from "@/assets/comment/play.png"
import shareImg from "@/assets/comment/share.png"
import { getCommentVideoApi, postCommentApi } from '@/services/YsApi/commentManage'
import dayjs from 'dayjs'
export const addUnit = (value) => {
  if (value < 10000) {
    return value || 0
  } else if (value >= 10000) {
    return (value / 10000).toFixed(1) + 'w'
  } else {
    return value || 0
  }
}

export default function WorkList({ third_uid, onClickItem, auth_data, team_id }) {
  const fetchId = useRef<any>({})
  const max_cursor = useRef(0)
  const [dataSource, setDataSource] = useState<any>([])
  const [loading, setLoading] = useState(false);
  const [scrollLoading, setScrollLoading] = useState<any>('——已经是底线了——')
  const [searchValue, setSearchValue] = useState('')
  const [searchText, setSearchText] = useState('')
  const [awemeId, setAwemeId] = useState('')
  const [awemeIds, setAwemeIds] = useState([])
  const [open, setOpen] = useState(false);
  const [textValue, setTextValue] = useState('')
  const [sendLoading, setSendLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const searchChange = (value) => {
    setSearchValue(value)
  }
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (!searchValue.trim()) {
        setSearchText('')
      } else {
        setSearchText(searchValue)
      }
      max_cursor.current = 0
      setHasMore(false)
      const params = {
        third_uid,
        count: 10,
        max_cursor: 0,
        team_id,
        keyword: searchValue.trim()
      }
      fetchId.current = JSON.stringify(params)
      getWorkList(params)
    }
  }
  const handleClick = (row) => {
    setAwemeId(row.aweme_id)
    onClickItem(row)
  }
  // 获取账号列表
  // const getAccountList = (payload: PageReqCommon<IaccountReq>) => {
  //   getAuthAccountListApi(payload).then(res => {
  //     if (JSON.stringify(payload) === fetchId.current) {
  //       // setAccountList(res.data.accounts);
  //       setTotal(res.data.total);
  //     }
  //   }).finally(() => {
  //     setLoading(false);
  //   })
  // }
  const getWorkList = (payload) => {
    getCommentVideoApi(payload).then(res => {
      if (JSON.stringify(payload) === fetchId.current) {
        setDataSource(res.data.aweme_list)
        // setHasMore(res.data.has_more)
        if (!res.data?.aweme_list?.length) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }
        if (!res.data?.max_cursor) {
          setHasMore(false)
        }
        max_cursor.current = res.data.max_cursor
      }
    }).finally(() => {
      setLoading(false)
    })
  }
  const handleSelect = (e, id) => {
    e.stopPropagation();
    if (awemeIds.includes(id)) {
      setAwemeIds(awemeIds.filter(item => item !== id))
    } else {
      console.log(11111111)
      setAwemeIds([...awemeIds, id])
    }
  }
  const handleCancel = () => {
    setAwemeIds([])
  }
  const handleClickAll = () => {
    if (awemeIds.length === dataSource.length) {
      setAwemeIds([])
    } else {
      setAwemeIds(dataSource.map(item => item.aweme_id))
    }
  }
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setTextValue('')
    setOpen(false)
  }
  const handleSend = () => {
    setSendLoading(true)
    postCommentApi({
      third_uid,
      items: awemeIds.map(item => {
        return {
          aweme_id: item,
          reply_to_comment_ids: ''
        }
      }),
      text: textValue,
      team_id
    }).then(() => {
      setTextValue('')
      setOpen(false)
      Message.success(`发送成功，已同步至${awemeIds.length}条作品`)
      setAwemeIds([])
    }).catch(err => {
      // Message.error(err)
    }).finally(() => {
      setSendLoading(false)
    })
    Promise.all(awemeIds.map(i => {
      return window?.electron?.ipcRenderer?.commentDouyin({ auth_data, aweme_id: i, reply_id: '', reply_to_reply_id: '', text: textValue })
    }))
  }
  const fetchData = (page) => {
    const payload = {
      third_uid,
      count: 10,
      max_cursor: max_cursor.current,
      keyword: searchText,
      team_id
    }
    if (!hasMore) return
    fetchId.current = JSON.stringify(payload)
    setScrollLoading(<Spin />)
    getCommentVideoApi(payload).then(res => {
      if (JSON.stringify(payload) === fetchId.current) {
        setDataSource([...dataSource, ...(res.data?.aweme_list || [])]);
        // setHasMore(res.data.has_more);
        if (!res.data?.aweme_list?.length) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }
        if (!res.data?.max_cursor) {
          setHasMore(false)
        }
        if (!res.data?.has_more) {
          setHasMore(false)
        }
        max_cursor.current = res.data.max_cursor
      }
    }).finally(() => {
      setLoading(false);
      setScrollLoading('——已经是底线了——')
    })
  }
  const handleToPlay = (e, url) => {
    e.stopPropagation();
    window.open(url)
  }
  useEffect(() => {
    if (third_uid) {
      setOpen(false)
      setAwemeIds([])
      setSearchValue('')
      max_cursor.current = 0
      setLoading(true)
      const params = {
        third_uid,
        count: 10,
        max_cursor: 0,
        team_id
      }
      setAwemeId('')
      onClickItem({ aweme_id: '', statistics: { comment_count: 0 } })
      fetchId.current = JSON.stringify(params)
      getWorkList(params)
    }
  }, [third_uid])
  return (
    <div className="work-list-wrapper">
      <div className="work-header">
        <div className="work-title">作品列表</div>
        <div className="work-btn-wrapper">
          <Button className="work-btn" type='primary' icon={<IconMessage />} size="small" disabled={awemeIds.length < 1} onClick={handleOpen}>发布评论</Button>
          {open && <div className="work-send">
            <Input.TextArea maxLength={300} showWordLimit rows={6} value={textValue} onChange={value => setTextValue(value)}></Input.TextArea>
            <div className="work-bottom">
              <Space>
                <Button className="send-btns" onClick={handleClose}>取消</Button>
                <Button className="send-btns" type="primary" disabled={!textValue} onClick={handleSend} loading={sendLoading}>发送</Button>
              </Space>
            </div>
          </div>}
          {
            open && <div className="work-mask"></div>
          }
        </div>
      </div>
      <div>
        <Input onChange={searchChange} value={searchValue} allowClear prefix={<IconSearch />} placeholder={'视频标题'} onKeyDown={onKeyDown} />
      </div>
      {awemeIds.length ? <div className="all-select">
        <div>
          <Checkbox
            onClick={handleClickAll}
            indeterminate={awemeIds.length > 0 && awemeIds.length < dataSource.length}
            checked={awemeIds.length > 0 && (awemeIds.length === dataSource.length)}
          >全选</Checkbox>
        </div>
        <div className="select-num">
          <div className="selected">已选<span className="a-num">{awemeIds.length}</span></div>
          <a onClick={handleCancel}>取消</a>
        </div>
      </div> : null}
      <div className="work-list">
        {loading ? <div style={{ height: 'calc(100vh - 190px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <Spin /> </div> :
          <List
            style={{ width: 295, maxHeight: `calc(100vh - ${awemeIds.length ? '214px' : '190px'})`, border: 'none' }}
            scrollLoading={scrollLoading}
            onReachBottom={(currentPage) => fetchData(currentPage)}
            dataSource={dataSource}
            render={(item, index) => {
              return (
                <div className={`work-item ${item.aweme_id === awemeId ? 'active' : ''}`} key={index} onClick={() => handleClick(item)}>
                  <div className="work-item-img">
                    <img className="img" src={item.cover.url_list[0]} alt="" />
                    <div className={`work-check ${awemeIds.includes(item.aweme_id) ? 'visible' : ''}`}>
                      <Checkbox checked={awemeIds.includes(item.aweme_id)} onClick={(e) => handleSelect(e, item.aweme_id)}></Checkbox>
                    </div>
                    <img className="work-icon" src={playImg} onClick={(e) => handleToPlay(e, item.share_url)} alt="" />
                  </div>
                  <div className="work-item-content">
                    <div className="work-item-title">
                      {item.desc}
                    </div>
                    <div className="love-row">
                      <div className="love-col">
                        <img src={playerImg} alt="" />
                        <span>{addUnit(item.statistics.play_count)}</span>
                      </div>
                      <div className="love-col">
                        <img src={loveImg} alt="" />
                        <span>{addUnit(item.statistics.digg_count)}</span>
                      </div>
                    </div>
                    <div className="love-row">
                      <div className="love-col">
                        <img src={collectImg} alt="" />
                        <span>{addUnit(item.statistics.collect_count)}</span>
                      </div>
                      <div className="love-col">
                        <img src={shareImg} alt="" />
                        <span>{addUnit(item.statistics.share_count)}</span>
                      </div>
                    </div>
                    <div className="work-desc">
                      发布于 {dayjs(item.create_time * 1000).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                    <div className="comment-num">
                      共{addUnit(item.statistics.comment_count)}条评论
                    </div>
                  </div>
                </div>
              )
            }}
          />}
      </div>
    </div>
  )
}
